<template>
  <section class="upgrade-banner" :class="'upgrade-banner--' + state" aria-label="Upgrade to the new Visceral Consignment">

    <!-- ============ 1. OFFER ============ -->
    <div v-if="state === 'offer'" class="ub-grid ub-grid--offer">
      <div class="ub-lede-col">
        <div class="ub-lede">
          <p class="ub-eyebrow">
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.6 5.6 6.1.8-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6L3.3 8.9l6.1-.8z"/></svg>
            <span>The New Visceral Consignment</span>
          </p>
          <h2 class="ub-title">Upgrade to the New Visceral Consignment</h2>
          <p class="ub-sub">Trusted by shops for over a year.</p>
          <p class="ub-sub ub-sub--two">Faster, more reliable, and continuously expanding with new features.</p>
        </div>

        <div class="ub-price">
          <div class="ub-price-main">
            <span class="ub-price-line"><span class="ub-amt">{{ price }}</span><span class="ub-per">/mo</span></span>
            <span class="ub-reg">reg. <s>{{ regularPrice }}/mo</s><span v-if="discountPercent" class="ub-save">Save {{ discountPercent }}%</span></span>
          </div>
          <p class="ub-pnote">Exclusive pricing for existing customers.</p>
        </div>
      </div>

      <div class="ub-rule ub-rule--one" aria-hidden="true"></div>

      <div class="ub-features">
        <div class="ub-feature">
          <span class="ub-fmark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5 9 17.5 20 6.5"/></svg>
          </span>
          <span class="ub-fdisc" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
              <path d="m9 12 2 2 4-4"/>
            </svg>
          </span>
          <div>
            <p class="ub-ftitle">
              <span class="ub-sm">Trusted by shops for over a year</span>
              <span class="ub-mid">Trusted for over a year</span>
              <span class="ub-full">Proven &amp; trusted</span>
            </p>
            <p class="ub-fbody">The new app has been trusted by consignment shops for over a year.</p>
          </div>
        </div>

        <div class="ub-feature">
          <span class="ub-fmark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5 9 17.5 20 6.5"/></svg>
          </span>
          <span class="ub-fdisc" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-1.8a4 4 0 0 0-4-4H6.5a4 4 0 0 0-4 4V21"/>
              <circle cx="9.25" cy="7.5" r="3.6"/>
              <path d="M21.5 21v-1.8a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.6a4 4 0 0 1 0 7.75"/>
            </svg>
          </span>
          <div>
            <p class="ub-ftitle">
              <span class="ub-sm">We'll handle the migration</span>
              <span class="ub-mid">We handle the migration</span>
              <span class="ub-full">We handle the migration</span>
            </p>
            <p class="ub-fbody">We prepare your shop, migrate your data, and verify everything before you switch.</p>
          </div>
        </div>

        <div class="ub-feature">
          <span class="ub-fmark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5 9 17.5 20 6.5"/></svg>
          </span>
          <span class="ub-fdisc" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 2.5v19"/>
              <path d="M17 5.8H9.9a3.6 3.6 0 0 0 0 7.2h4.4a3.6 3.6 0 0 1 0 7.2H6.4"/>
            </svg>
          </span>
          <div>
            <p class="ub-ftitle">
              <span class="ub-sm">Your exclusive {{ discountPercent }}% discount is honored</span>
              <span class="ub-mid">Exclusive {{ discountPercent }}% discount</span>
              <span class="ub-full">Your exclusive {{ discountPercent }}% discount</span>
            </p>
            <p class="ub-fbody">Exclusive pricing on the Premium plan, reserved for existing customers.</p>
          </div>
        </div>
      </div>

      <div class="ub-rule ub-rule--two" aria-hidden="true"></div>

      <div class="ub-assure">
        <div class="ub-ahead">
          <span class="ub-fdisc" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="m11 17 2 2a1 1 0 1 0 3-3"/>
              <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/>
              <path d="m21 3 1 11h-2"/>
              <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/>
              <path d="M3 4h8"/>
            </svg>
          </span>
          <h3>A smooth transition</h3>
        </div>
        <p class="ub-apara">You don't have to figure it out yourself. We'll prepare your shop, migrate your data, and verify everything before you switch—so you can keep running your business as usual.</p>
        <ul class="ub-checks">
          <li>
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.6 12.2 2.9 2.9 5.9-6" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg>
            We prepare everything before migration
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.6 12.2 2.9 2.9 5.9-6" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Your data and history come with you
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.6 12.2 2.9 2.9 5.9-6" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg>
            No interruption to day-to-day operations
          </li>
        </ul>
      </div>

      <div class="ub-action">
        <a class="ub-cta" href="#" @click.prevent="$emit('open-offer')">See my upgrade offer
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>
        </a>
        <a class="ub-learn" href="#" @click.prevent="$emit('open-offer')">Learn what to expect
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>
        </a>
      </div>

      <p class="ub-fine"><a href="#" @click.prevent="$emit('watch-video', 'whyMove')">Watch why shops are moving ({{ videos.whyMove.duration }})</a> · No commitment. Cancel anytime.</p>
    </div>

    <!-- ============ 2. ACCEPTED, NOT YET STARTED ============ -->
    <div v-else-if="state === 'accepted'" class="ub-grid ub-grid--status">
      <div class="ub-lede-col">
        <div class="ub-lede">
          <p class="ub-eyebrow ub-eyebrow--locked">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="10.5" width="16" height="10" rx="2"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></svg>
            <span>Your upgrade is reserved</span>
          </p>
          <h2 class="ub-title">You're on the list for the new app</h2>
          <p class="ub-sub">Accepted {{ acceptedDate }}.</p>
          <p class="ub-sub ub-sub--two">Ready when you are. Nothing changes on your account until you approve the switch.</p>
        </div>

        <div class="ub-price">
          <div class="ub-price-main">
            <span class="ub-price-line"><span class="ub-amt">{{ price }}</span><span class="ub-per">/mo</span></span>
            <span class="ub-reg">reg. <s>{{ regularPrice }}/mo</s><span v-if="discountPercent" class="ub-save">Save {{ discountPercent }}%</span></span>
          </div>
          <p class="ub-pnote">Reserved for your upgrade.</p>
        </div>
      </div>

      <div class="ub-rule ub-rule--one" aria-hidden="true"></div>

      <div class="ub-assure">
        <div class="ub-ahead">
          <span class="ub-fdisc" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="9.2"/>
              <path d="m8.5 12 2.4 2.4 4.6-4.8"/>
            </svg>
          </span>
          <h3>What happens next</h3>
        </div>
        <p class="ub-apara">The first step is a quick permission update in Shopify, so the new app can copy your data. Press Continue and we'll prepare it; then approve it in Shopify. Our team takes it from there and lets you review everything before the switch.</p>
        <div class="ub-action ub-action--continue">
          <a
            v-if="shop.scope_update_required && shop.scope_update_auth_url"
            class="ub-cta"
            :href="shop.scope_update_auth_url"
            target="_blank"
            rel="noopener"
            @click="permissionsOpened">Update permissions
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>
          </a>
          <a
            v-else
            class="ub-cta"
            :class="{ 'ub-cta--busy': continueState === 'preparing' }"
            href="#"
            :aria-disabled="continueState === 'preparing'"
            @click.prevent="continueMigration">{{ continueState === 'preparing' ? 'Preparing…' : 'Continue my migration' }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>
          </a>
          <p v-if="continueMessage" class="ub-status" :class="{ 'ub-status--error': continueState === 'failed' }">{{ continueMessage }}</p>
        </div>
        <ul class="ub-checks">
          <li>
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.6 12.2 2.9 2.9 5.9-6" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Your pricing is locked in
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.6 12.2 2.9 2.9 5.9-6" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg>
            No billing changes until migration is complete
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.6 12.2 2.9 2.9 5.9-6" fill="none" stroke="#fff" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Keep working as usual in the meantime
          </li>
        </ul>
      </div>

      <p class="ub-fine"><a href="#" @click.prevent="$emit('watch-video', 'moving')">Watch how the move works ({{ videos.moving.duration }})</a> · Questions? <a :href="supportMailto">Email us about your upgrade</a>.</p>
    </div>

    <!-- ============ 3. MIGRATION IN PROGRESS ============ -->
    <div v-else class="ub-grid ub-grid--status">
      <div class="ub-lede-col">
        <div class="ub-lede">
          <p class="ub-eyebrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v18M5 10l7-7 7 7"/></svg>
            <span>Upgrade in progress</span>
          </p>
          <h2 class="ub-title">Your migration is underway</h2>
          <p class="ub-sub">Accepted {{ acceptedDate }}.</p>
          <p class="ub-sub ub-sub--two">Here's where things stand. We'll let you know whenever we need something from you.</p>
        </div>

        <div class="ub-price">
          <div class="ub-price-main">
            <span class="ub-price-line"><span class="ub-amt">{{ price }}</span><span class="ub-per">/mo</span></span>
            <span class="ub-reg">reg. <s>{{ regularPrice }}/mo</s><span v-if="discountPercent" class="ub-save">Save {{ discountPercent }}%</span></span>
          </div>
          <p class="ub-pnote">Your locked-in pricing applies once you're live.</p>
        </div>
      </div>

      <div class="ub-rule ub-rule--one" aria-hidden="true"></div>

      <div class="ub-assure">
        <MigrationProgress
          :shop="shop"
          :continue-state="continueState"
          :continue-message="continueMessage"
          :review-state="reviewState"
          :review-message="reviewMessage"
          @review="openReview"
          @continue="continueMigration"
          @open-permissions="permissionsOpened"
          @activate="$emit('activate')" />
      </div>

      <p class="ub-fine"><a href="#" @click.prevent="$emit('watch-video', 'moving')">Watch how the move works ({{ videos.moving.duration }})</a> · Questions? <a :href="supportMailto">Email us about your upgrade</a>.</p>
    </div>

  </section>
</template>

<script>
import client from '@/mixins/client'
import MigrationProgress from './MigrationProgress'
import { upgradeVideos } from './upgradeVideos'

const POLL_INTERVAL_MS = 5000
// Preparing takes the new app from a few seconds to about a minute.
const PREPARE_TIMEOUT_MS = 2 * 60 * 1000
// Approving in Shopify happens in another tab; keep this one in step for a while.
const GRANT_TIMEOUT_MS = 10 * 60 * 1000

export default {
  name: 'UpgradeBanner',
  mixins: [client],
  components: {
    MigrationProgress
  },
  props: {
    shop: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      price: '$39.99',
      regularPrice: '$59.99',
      supportMailto: 'mailto:support@visceralapps.zohodesk.com?subject=Question%20about%20my%20upgrade',
      // The new app's migration videos (upgradeVideos.js). Links emit watch-video; the dashboard
      // plays them in UpgradeVideoModal.
      videos: upgradeVideos,
      // Continue my migration: 'idle' | 'preparing' (the new app is preparing the permission
      // update) | 'waiting' (they opened Shopify's approval screen) | 'failed'.
      continueState: 'idle',
      continueMessage: '',
      // Review your data: 'idle' | 'opening' | 'failed'.
      reviewState: 'idle',
      reviewMessage: '',
      pollTimer: null,
      pollStartedAt: 0
    }
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    // The new app starts (or re-checks) the migration and asks for the permissions it needs,
    // which turns on scope_update_required and the Update permissions button.
    continueMigration () {
      if (this.continueState === 'preparing') return
      this.continueState = 'preparing'
      this.continueMessage = 'Preparing your permission update. This usually takes under a minute.'
      // Polling starts with the request, so a request that never settles still times out.
      this.poll(
        shop => shop.scope_update_required || shop.upgrade_process_step >= 2,
        PREPARE_TIMEOUT_MS,
        () => this.fail('This is taking longer than expected. Refresh the page in a few minutes, or email us below.')
      )
      this.request('patch', '/shopify/shops/continue-migration/', {}).catch(error => {
        this.fail((error && error.detail) || "We couldn't start this just now. Please try again in a few minutes, or email us below.")
      })
    },
    // The new app answers with a short-lived link into the merchant's review, which signs them
    // in there. The tab is opened on the click itself (a tab opened after the request returns
    // is blocked as a popup) and pointed at the link once it arrives.
    openReview () {
      if (this.reviewState === 'opening') return
      const tab = window.open('', '_blank')
      this.reviewState = 'opening'
      this.reviewMessage = ''
      this.request('post', '/shopify/shops/review-link/', {}).then(response => {
        if (!response || !response.url) throw response
        if (tab) {
          tab.location = response.url
        } else {
          window.location.href = response.url
        }
        this.reviewState = 'idle'
      }).catch(error => {
        if (tab) tab.close()
        this.reviewState = 'failed'
        this.reviewMessage = (error && error.detail) || "We couldn't open your review just now. Please try again in a few minutes, or email us below."
      })
    },
    // Shopify's approval screen opens in a new tab; once it's approved the new app moves the
    // shop to step 2, and this tab catches up.
    permissionsOpened () {
      this.continueState = 'waiting'
      this.continueMessage = "Once you've approved the permissions in Shopify, this page updates by itself."
      this.poll(
        shop => !shop.scope_update_required && shop.upgrade_process_step >= 2,
        GRANT_TIMEOUT_MS,
        () => this.reset()
      )
    },
    poll (done, timeoutMs, onTimeout) {
      this.stopPolling()
      this.pollStartedAt = Date.now()
      this.pollTimer = setInterval(() => {
        if (Date.now() - this.pollStartedAt > timeoutMs) {
          this.stopPolling()
          onTimeout()
          return
        }
        this.request('get', '/shopify/shops/').then(response => {
          const shop = response && response.results && response.results[0]
          if (!shop || !this.pollTimer) return
          this.$store.commit('setShop', {shop})
          if (done(shop)) {
            this.stopPolling()
            this.reset()
          }
        }).catch(() => {})
      }, POLL_INTERVAL_MS)
    },
    stopPolling () {
      if (this.pollTimer) clearInterval(this.pollTimer)
      this.pollTimer = null
    },
    fail (message) {
      this.stopPolling()
      this.continueState = 'failed'
      this.continueMessage = message
    },
    reset () {
      this.continueState = 'idle'
      this.continueMessage = ''
    }
  },
  computed: {
    // Three mutually exclusive states, driven by the shop record:
    //   offer    – hasn't accepted yet (the common case)
    //   accepted – accepted, migration not started yet (Continue my migration starts it)
    //   progress – migration underway, show the step checklist
    state () {
      if (!this.shop.agree_to_upgrade) return 'offer'
      return this.shop.upgrade_process_step > 0 ? 'progress' : 'accepted'
    },
    // Derived from the two prices above so the badge can never drift from them.
    discountPercent () {
      const now = parseFloat(String(this.price).replace(/[^0-9.]/g, ''))
      const reg = parseFloat(String(this.regularPrice).replace(/[^0-9.]/g, ''))
      if (!now || !reg || reg <= now) return 0
      return Math.round((1 - now / reg) * 100)
    },
    acceptedDate () {
      if (!this.shop.agree_to_upgrade_datetime) return ''
      return new Date(this.shop.agree_to_upgrade_datetime).toLocaleDateString()
    }
  }
}
</script>

<style lang="scss" scoped>
// The upgrade banner is a promotional insert, not a dashboard panel: it keeps its own
// white / violet / gold identity in both the dark and the light dashboard theme. Every
// colour, font and margin below is therefore stated explicitly so that neither the global
// typography rules nor the `light-theme` body class can bleed into it.
.upgrade-banner {
  --ub-ink: #2a1a63;
  --ub-ink-soft: #514b6b;
  --ub-violet: #6b32d6;
  --ub-violet-tint: #f3eafd;
  --ub-violet-line: #ede6f8;
  --ub-gold: #f5b32c;
  --ub-gold-hi: #ffc348;
  --ub-line: #e9e5f2;
  --ub-muted: #9a95ad;

  background: #fff;
  border: 1px solid var(--ub-line);
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(42, 26, 99, .04), 0 10px 30px -18px rgba(42, 26, 99, .25);
  position: relative;
  overflow: hidden;
  padding: 20px 18px;
  margin-bottom: 20px;
  font-family: Roboto, Helvetica, sans-serif;
  color: var(--ub-ink-soft);
  -webkit-font-smoothing: antialiased;
}

.ub-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

// The lede and the price live in one wrapper so they can share a column in the widest
// layout (see the >=1000px block). Everywhere below that the wrapper is transparent and
// both stay direct grid items, placed by the named areas exactly as before.
.ub-lede-col {
  display: contents;
}

// Sitting next to the lede in the DOM would float the price above the feature list in the
// stacked layout; ordering restores the intended reading order: pitch, features, price,
// call to action, fine print.
.ub-price { order: 1; }
.ub-action { order: 2; }
.ub-fine { order: 3; }

/* ---------- lede ---------- */
.ub-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: var(--ub-violet-tint);
  color: var(--ub-violet);
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: .11em;
  text-transform: uppercase;
  padding: 7px 11px;
  border-radius: 999px;
  margin: 0 0 12px;

  svg {
    width: 12px;
    height: 12px;
    flex: none;
  }
}

.ub-title {
  font-size: 17px;
  font-weight: 900;
  line-height: 1.22;
  letter-spacing: -.015em; // the global h2 rule adds +1px tracking; override it outright
  color: var(--ub-ink);
  // The gap below the headline lives here rather than on .ub-sub: the subs are inline in
  // the stacked layout and inline boxes ignore vertical margin. From 640px up this
  // collapses with .ub-sub's margin-top, so the spacing is unchanged there.
  margin: 0 0 8px;
}

.ub-sub {
  // Stacked layout: the two sentences read as one flowing paragraph instead of taking a
  // line each. The newline between the two <p> tags collapses to the separating space.
  display: inline;
  margin: 8px 0 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--ub-ink-soft);

  &--two {
    display: inline;
  }
}

/* ---------- features ---------- */
.ub-features {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.ub-feature {
  display: flex;
  gap: 9px;
  align-items: flex-start;
}

.ub-fmark {
  flex: none;
  color: var(--ub-violet);
  display: grid;
  place-items: center;

  svg {
    width: 15px;
    height: 15px;
    display: block;
  }
}

// The disc treatment only appears from the condensed layout up.
.ub-fdisc {
  display: none;
  flex: none;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: var(--ub-violet-tint);
  color: var(--ub-violet);
  place-items: center;

  svg {
    width: 19px;
    height: 19px;
  }
}

.ub-ftitle {
  font-size: 12.5px;
  font-weight: 700;
  line-height: 1.35;
  color: var(--ub-ink);
  margin: 0;

  .ub-mid,
  .ub-full {
    display: none;
  }
}

.ub-fbody {
  display: none;
  margin: 5px 0 0;
  font-size: 12.5px;
  line-height: 1.5;
}

/* ---------- price ---------- */
.ub-price {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.ub-price-main {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}

.ub-amt {
  font-size: 26px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -.02em;
  color: var(--ub-violet);
}

.ub-per {
  font-size: 14px;
  font-weight: 700;
  color: var(--ub-violet);
}

.ub-reg {
  font-size: 11.5px;
  color: var(--ub-muted);

  s {
    text-decoration-thickness: 1px;
  }
}

// Sits beside the amount so the saving is read against the struck-through regular price
// without the merchant having to do the arithmetic. Violet rather than gold: the gold is
// reserved for the call to action and a second gold element would compete with it.
.ub-save {
  display: inline-block;
  margin-left: 8px;
  padding: 4px 7px;
  border-radius: 999px;
  background: var(--ub-violet-tint);
  color: var(--ub-violet);
  font-size: 10.5px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: .06em;
  text-transform: uppercase;
  white-space: nowrap;
  vertical-align: middle;
}

.ub-pnote {
  display: none;
}

/* ---------- assurance / status column ---------- */
.ub-assure {
  min-width: 0;
}

// In the offer state the assurance column is the third desktop column only — below the
// full layout the features list already carries the same reassurance in short form.
.ub-grid--offer .ub-assure {
  display: none;
}

.ub-ahead {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 8px;

  h3 {
    font-size: 18px;
    font-weight: 900;
    letter-spacing: -.02em;
    line-height: 1.15;
    color: var(--ub-ink);
    margin: 0;
  }

  .ub-fdisc {
    display: grid;
    width: 38px;
    height: 38px;
    margin-top: 2px;
  }
}

.ub-apara {
  margin: 0 0 6px;
  font-size: 13px;
  line-height: 1.42;
  color: var(--ub-ink-soft);
}

.ub-checks {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;

  li {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: var(--ub-ink-soft);
  }

  svg {
    flex: none;
    width: 16px;
    height: 16px;
    color: var(--ub-violet);
  }
}

/* ---------- action ---------- */
.ub-action {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
}

.ub-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: var(--ub-gold);
  color: #241543; // the global `a` rule paints links with --primary-color; override it
  text-decoration: none;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: .045em;
  text-transform: uppercase;
  padding: 14px 18px;
  border-radius: 9px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, .06);
  transition: background .15s, transform .15s, box-shadow .15s;

  svg {
    width: 15px;
    height: 15px;
    transition: transform .18s;
  }

  &:hover,
  &:focus {
    background: var(--ub-gold-hi);
    color: #241543;
    box-shadow: 0 6px 16px -8px rgba(180, 120, 0, .65);
  }

  &:hover svg {
    transform: translateX(3px);
  }

  &:active {
    transform: translateY(1px);
  }
}

.ub-learn {
  display: none;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  color: var(--ub-violet);
  text-decoration: none;

  &:hover,
  &:focus {
    color: var(--ub-violet);
    text-decoration: underline;
  }

  svg {
    width: 13px;
    height: 13px;
  }
}

.ub-action--continue {
  margin: 12px 0 4px;
}

.ub-cta--busy {
  opacity: .7;
  cursor: default;
}

.ub-status {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--ub-ink-soft);

  &--error {
    color: #b42318;
  }
}

.ub-fine {
  margin: 0;
  font-size: 11.5px;
  color: var(--ub-muted);

  a {
    color: var(--ub-violet);
    text-decoration: underline;

    &:hover,
    &:focus {
      color: var(--ub-violet);
    }
  }
}

.ub-rule {
  display: none;
  background: var(--ub-violet-line);
}

.ub-cta:focus-visible,
.ub-learn:focus-visible {
  outline: 2px solid var(--ub-violet);
  outline-offset: 2px;
}

/* =========================================================
   CONDENSED — tablet / narrow desktop
   The concept used container queries; the dashboard has no sidebar, so the banner
   tracks the viewport and plain media queries give the same result on a toolchain
   (autoprefixer 7 / node-sass 4) that predates @container.
   ========================================================= */
@media (min-width: 640px) {
  .upgrade-banner {
    padding: 20px 22px;
  }

  .ub-grid--offer {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "lede  price"
      "feat  action"
      "fine  action";
    column-gap: 28px;
    row-gap: 14px;
    align-items: start;
  }

  .ub-grid--status {
    grid-template-columns: minmax(0, 1fr) auto;
    grid-template-areas:
      "lede   price"
      "assure assure"
      "fine   fine";
    column-gap: 28px;
    row-gap: 16px;
    align-items: start;
  }

  .ub-lede { grid-area: lede; }
  .ub-features { grid-area: feat; }
  .ub-assure { grid-area: assure; }

  .ub-price {
    grid-area: price;
    justify-self: end;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
  }

  .ub-action {
    grid-area: action;
    justify-self: end;
    align-items: flex-end;
    gap: 8px;
  }

  .ub-fine {
    grid-area: fine;
    align-self: end;
  }

  .ub-title {
    font-size: 19px;
  }

  // The condensed bar is deliberately terse: back to a single block sentence.
  .ub-sub {
    display: block;

    &--two {
      display: inline;
    }
  }

  .ub-eyebrow {
    margin-bottom: 10px;
    padding: 6px 10px;
  }

  .ub-features {
    flex-direction: row;
    gap: 22px;
    flex-wrap: wrap;
  }

  .ub-feature {
    align-items: center;
    gap: 9px;
    max-width: 180px;
  }

  .ub-fmark {
    display: none;
  }

  .ub-fdisc {
    display: grid;
    width: 30px;
    height: 30px;

    svg {
      width: 15px;
      height: 15px;
    }
  }

  .ub-ftitle {
    font-size: 11.5px;
    line-height: 1.3;

    .ub-sm { display: none; }
    .ub-mid { display: inline; }
  }

  .ub-amt {
    font-size: 24px;
  }

  .ub-learn {
    display: inline-flex;
  }
}

/* =========================================================
   FULL — three-column desktop
   ========================================================= */
@media (min-width: 1000px) {
  .upgrade-banner {
    padding: 16px 34px 18px 40px;
    border-radius: 16px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 7px;
      background: var(--ub-violet);
    }
  }

  // The lede and the price are one column that spans every row, so the price hangs off the
  // bottom of the copy at a fixed distance. As separate grid items they were tied to the
  // row grid, and any row the other columns grew — the assurance text gaining a line around
  // 1200px, for instance — pushed the price down and opened a gap under the lede.
  .ub-lede-col {
    display: flex;
    flex-direction: column;
    grid-area: lede;
  }

  .ub-grid--offer {
    grid-template-columns: minmax(0, 1.12fr) 1px minmax(0, 1fr) 1px minmax(0, 1.06fr);
    grid-template-rows: auto auto auto;
    grid-template-areas:
      "lede r1 feat r2 assure"
      "lede r1 feat r2 action"
      "lede r1 feat r2 fine";
    column-gap: 34px;
    row-gap: 10px;
  }

  .ub-grid--status {
    grid-template-columns: minmax(0, 1fr) 1px minmax(0, 1.5fr);
    grid-template-rows: auto 1fr auto;
    grid-template-areas:
      "lede r1 assure"
      "lede r1 assure"
      "fine r1 assure";
    column-gap: 34px;
    row-gap: 10px;
  }

  .ub-rule {
    display: block;

    &--one { grid-area: r1; }
    &--two { grid-area: r2; }
  }

  .ub-grid--offer .ub-assure {
    display: block;
  }

  .ub-eyebrow {
    font-size: 11px;
    padding: 6px 12px;
    margin-bottom: 10px;
  }

  .ub-title {
    font-size: 30px;
    line-height: 1.1;
    letter-spacing: -.025em;
  }

  // The status states run two columns instead of three, so the headline has room to
  // breathe and the status column sits centred against the taller lede stack.
  .ub-grid--status {
    .ub-title {
      font-size: 26px;
    }

    .ub-assure {
      align-self: center;
    }

    .ub-pnote {
      max-width: 22ch;
    }
  }

  .ub-sub {
    font-size: 14px;
    line-height: 1.4;
    margin-top: 9px;

    &--two {
      display: block;
      margin-top: 4px;
    }
  }

  // The price becomes a bordered module of its own, sitting directly beneath the lede.
  .ub-price {
    margin-top: 14px;
    align-self: flex-start;
    flex-direction: row;
    align-items: center;
    gap: 0;
    border: 1px solid var(--ub-line);
    border-radius: 11px;
    padding: 9px 18px;
    width: 100%;
    max-width: 400px;
  }

  .ub-price-main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding-right: 16px;
  }

  .ub-price-line {
    display: flex;
    align-items: baseline;
    gap: 2px;
  }

  .ub-amt { font-size: 27px; }
  .ub-per { font-size: 15px; }
  .ub-reg { font-size: 12px; }

  .ub-pnote {
    display: block;
    margin: 0;
    padding-left: 16px;
    border-left: 1px solid var(--ub-line);
    font-size: 12.5px;
    line-height: 1.35;
    color: var(--ub-ink-soft);
    max-width: 13ch;
    @media (min-width: 1180px) {
      max-width: 16ch;
    }
    @media (min-width: 1240px) {
      max-width: 19ch;
    }
  }

  // Between 1000 and 1120 the three columns still work, but the left one is too narrow to
  // seat the price and its note side by side — flex-wrap would drop the note below while it
  // kept the divider's indent, which reads as a mistake. Stack them deliberately instead.
  // Selectors are qualified with .ub-grid so they outrank the single-class rules above on
  // specificity: cssnano reorders equal-specificity rules in the production build.
  @media (max-width: 1119px) {
    .ub-grid .ub-price {
      flex-direction: column;
      align-items: flex-start;
    }

    .ub-grid .ub-price-main {
      padding-right: 0;
    }

    .ub-grid .ub-pnote {
      padding-left: 0;
      border-left: 0;
      margin-top: 5px;
      max-width: none;
    }

    // The pill is a fixed string; at this column width it breaks over two lines.
    .ub-grid .ub-eyebrow {
      font-size: 11px;
      white-space: nowrap;
    }
  }

  // Features become stacked rows separated by hairlines.
  .ub-features {
    flex-direction: column;
    gap: 0;
    justify-content: center;
  }

  .ub-feature {
    align-items: flex-start;
    gap: 14px;
    max-width: none;
    padding: 11px 0;

    + .ub-feature {
      border-top: 1px solid var(--ub-violet-line);
    }
  }

  .ub-fdisc {
    width: 38px;
    height: 38px;

    svg {
      width: 19px;
      height: 19px;
    }
  }

  .ub-ftitle {
    font-size: 15px;
    letter-spacing: -.01em;

    .ub-mid { display: none; }
    .ub-full { display: inline; }
  }

  .ub-fbody {
    display: block;
    font-size: 12.5px;
    line-height: 1.4;
    max-width: 34ch;
  }

  .ub-ahead {
    h3 { font-size: 19px; }

    .ub-fdisc {
      width: 38px;
      height: 38px;
    }
  }

  .ub-apara { font-size: 12.5px; }

  .ub-checks li { font-size: 12.5px; }

  .ub-action {
    justify-self: start;
    align-self: end;
    align-items: stretch;
    gap: 0;
    width: 100%;

    .ub-cta {
      padding: 11px 22px;
      font-size: 12.5px;
      border-radius: 10px;
    }
  }

  .ub-learn {
    display: none;
  }

  .ub-fine {
    font-size: 12px;
    align-self: start;
  }
}

@media (prefers-reduced-motion: reduce) {
  .ub-cta,
  .ub-cta svg {
    transition: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/components/UpgradeBanner.vue